var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6875 0C21.5713 0 10.4375 0 10.4375 0C8.45373 0 6.68752 1.8197 6.68752 3.75002L5.60376 3.77533C3.62094 3.77533 2 5.56968 2 7.5V26.25C2 28.1803 3.76626 30 5.75002 30H19.8125C21.7962 30 23.5625 28.1803 23.5625 26.25H24.5C26.4838 26.25 28.25 24.4304 28.25 22.5V7.52252L21.6875 0ZM19.8125 28.1251H5.75002C4.76565 28.1251 3.87503 27.2054 3.87503 26.25V7.5C3.87503 6.5447 4.6766 5.65594 5.66098 5.65594L6.68752 5.62501V22.5C6.68752 24.4304 8.45373 26.25 10.4375 26.25H21.6875C21.6875 27.2054 20.7969 28.1251 19.8125 28.1251ZM26.375 22.5C26.375 23.4553 25.4844 24.375 24.5 24.375H10.4375C9.45312 24.375 8.56251 23.4553 8.56251 22.5V3.75002C8.56251 2.79473 9.45312 1.87503 10.4375 1.87503H19.8125C19.7975 4.0341 19.8125 5.64847 19.8125 5.64847C19.8125 7.59659 21.5656 9.37503 23.5625 9.37503C23.5625 9.37503 24.5582 9.37503 26.375 9.37503V22.5ZM23.5625 7.5C22.5641 7.5 21.6875 5.68596 21.6875 4.71282C21.6875 4.71282 21.6875 3.72656 21.6875 1.90407V1.90218L26.375 7.5H23.5625Z",
    fill: "#727272"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 15,
    width: 2,
    height: 12,
    rx: 1,
    transform: "rotate(90 23 15)",
    fill: "#727272"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 2,
    height: 12,
    rx: 1,
    transform: "rotate(-180 18 22)",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.d3e8c643feaab5110bf83f04363a467b.svg";
export { ForwardRef as ReactComponent };